/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Release_Dialog_EyebrowInputs */



/**
* | output |
* | --- |
* | "New in {version}" |
*
* @param {Release_Dialog_EyebrowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const release_dialog_eyebrow = /** @type {((inputs: Release_Dialog_EyebrowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Release_Dialog_EyebrowInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Neu in ${i?.version}`)
	return /** @type {LocalizedString} */ (`New in ${i?.version}`)
});